import { useInView } from 'lib/useInView';
import { PlayCircle } from 'lucide-react';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { withTranslation } from 'utils/with-i18next';

const ArcadeSection = ({ t }) => {
  const router = useRouter();
  const locale = router.locale || 'ko';

  const [ref, isInView] = useInView({ threshold: 0.2 });

  return (
    <section className="py-24 md:py-32 bg-gradient-to-b from-background to-gray-900/50" ref={ref}>
      <div
        className={`max-w-5xl mx-auto px-6 md:px-12 transition-all duration-700 ${
          isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-14 h-14 bg-primary/10 rounded-2xl mb-6">
            <PlayCircle className="w-7 h-7 text-primary" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">{t('arcade.title') || 'How It Works'}</h2>
          {/* <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            {t('arcade.subtitle') || '간단한 데모로 BGMs의 작동 방식을 알아보세요'}
          </p> */}
        </div>

        {/* Video Container */}
        <div className="relative bg-gradient-to-br from-gray-900/90 to-gray-900/50 rounded-2xl p-2 border border-gray-800 shadow-2xl backdrop-blur-sm">
          <div className="relative w-full pt-[56.25%] rounded-xl overflow-hidden bg-black">
            <iframe
              src={`https://demo.arcade.software/r7Z9PySEtNbsAxWhnLTa?embed&embed_mobile=tab&embed_desktop=inline&locale=${locale}`}
              title="Jukebox Demo"
              frameBorder="0"
              loading="lazy"
              allowFullScreen
              allow="clipboard-write"
              className="absolute top-0 left-0 w-full h-full"
              style={{ colorScheme: 'light' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

ArcadeSection.propTypes = {
  t: PropTypes.func,
};

export default withTranslation('index')(ArcadeSection);
